import { createSelector } from '@ngrx/store';
import { ILocationsReducerState } from './locations.reducer';
import { buildingsList } from '@app/layout/state/layout.selectors';

export const selectLocationsState = (state: { locations: ILocationsReducerState }) =>
	state.locations;

export const filteredBuildings = createSelector(
	selectLocationsState,
	buildingsList,
	(locationsState, buildingsList) =>
		buildingsList?.filter(building =>
			building.name.toLowerCase().includes(locationsState.searchText.toLowerCase())
		)
);

export const searchText = createSelector(
	selectLocationsState,
	locationsState => locationsState.searchText
);

export const locationAncestryNames = createSelector(buildingsList, buildingsList => {
	const names = new Map<string, string>();
	if (!buildingsList) {
		return names;
	}
	for (const building of buildingsList) {
		for (const floor of building?.floor) {
			names.set(floor.id, building.name + ' | ' + floor.name);
			for (const room of floor?.room) {
				names.set(room.id, building.name + ' | ' + floor.name + ' | ' + room.name);
			}
		}
	}
	return names;
});
